module.exports = __webpack_public_path__ + "img/item-b2.b2ed8196.png";